var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRequestsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.5H11.073C11.6414 22.5 12.161 22.8213 12.4149 23.3298L13.0844 24.6702C13.3384 25.1787 13.8579 25.5 14.4263 25.5H21.5722C22.1404 25.5 22.6598 25.179 22.9138 24.6708L23.5847 23.3292C23.8388 22.821 24.3581 22.5 24.9263 22.5H31.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 4.5C29.4853 4.5 31.5 6.51472 31.5 9V27C31.5 29.4853 29.4853 31.5 27 31.5H9C6.51472 31.5 4.5 29.4853 4.5 27V9C4.5 6.51472 6.51472 4.5 9 4.5H27Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6667V11.1667",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.6675L18 18.6675L21 15.6675",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRequestsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RequestsIcon.35cd6b0f.svg";
export { ForwardRef as ReactComponent };